<template>
  <div>
    <b-modal
      id="contactPersonModal"
      ref="contactPersonModal"
      ok-variant="primary"
      cancel-variant="link"
      :ok-title="$t('message.contactPersonDialog.btn.submit')"
      :cancel-title="$t('message.contactPersonDialog.btn.cancel')"
      @ok="onSubmit">
      <div slot="modal-title">
        <span class="ti-user"></span>
        {{ $t('message.contactPersonDialog.title') }}
      </div>
      <b-form
        @submit.prevent="submit">
        <b-form-group
          id="contactPersonSalutation"
          label-for="contactPersonSalutation">
          <div slot="label">
            {{ $t('message.contactPersonDialog.label.salutation') }}
            <span class="text-danger">*</span>
          </div>
          <b-form-radio-group v-model="contactPerson.salutation"
                              :options="salutations"
                              :state="$v.contactPerson.salutation.$error ? false : null"
                              @change="$v.contactPerson.salutation.$touch()">
          </b-form-radio-group>
        </b-form-group>
        <b-form-row>
          <b-col>
            <b-form-group
              id="contactPersonFirstName"
              label-for="contactPersonFirstName">
              <div slot="label">
                {{ $t('message.contactPersonDialog.label.firstName') }}
                <span class="text-danger">*</span>
              </div>
              <b-form-input
                class="rounded-0"
                v-model="contactPerson.firstName"
                :state="$v.contactPerson.firstName.$error ? false : null"
                @change="$v.contactPerson.firstName.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="contactPersonLastName"
              label-for="contactPersonLastName">
              <div slot="label">
                {{ $t('message.contactPersonDialog.label.lastName') }}
                <span class="text-danger">*</span>
              </div>
              <b-form-input
                class="rounded-0"
                v-model="contactPerson.lastName"
                :state="$v.contactPerson.lastName.$error ? false : null"
                @change="$v.contactPerson.lastName.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-group
          id="contactPersonEmail"
          label-for="contactPersonEmail">
          <div slot="label">
            {{ $t('message.contactPersonDialog.label.email') }}
            <span class="text-danger">*</span>
          </div>
          <b-form-input
            class="rounded-0"
            v-model="contactPerson.email"
            :state="$v.contactPerson.email.$error ? false : null"
            @change="$v.contactPerson.email.$touch()">
          </b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
  import { email, required } from 'vuelidate/lib/validators'
  export default {
    name: 'ContactPersonDialog',
    data () {
      return {
        contactPerson: {},
        salutations: [
          { value: 'MR', text: this.$t('enums.salutations.MR') },
          { value: 'MRS', text: this.$t('enums.salutations.MRS') }
        ]
      }
    },
    methods: {
      onSubmit (bvEvt) {
        bvEvt.preventDefault()
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$refs.contactPersonModal.hide()
          this.$emit('submit', this.contactPerson)
        }
      },
      show () {
        this.$v.$reset()
        this.contactPerson = {}
        this.$refs.contactPersonModal.show()
      }
    },
    validations: {
      contactPerson: {
        email: {
          required,
          email
        },
        firstName: {
          required
        },
        lastName: {
          required
        },
        salutation: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contactPerson/ContactPersonDialog.vue